import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormSelect } from '../../../../components/ui/form';

const BasicSelect = ({ form, row, optionsData, getComponent }) => {
  const { wrapperClass = 'name_filed', menuPlacement = 'auto' } = row;
  const { watch } = form;
  const required = watch(row.key);
  return (
    <>
      <FormField
        control={form.control}
        name={row.key}
        render={({ field }) => {
          return (
            <FormItem className={`form_group   ${row.className} ${wrapperClass}`}>
              <FormLabel className="form-label">
                {row.label} {!!row.required && <span className="error">*</span>}
              </FormLabel>
              <FormControl className="m-0">
                <FormSelect
                  field={field}
                  required={row?.required}
                  row={row}
                  value={field.value}
                  menuPlacement={menuPlacement}
                  placeholder={row.placeholder}
                  options={optionsData?.[row.key] || row?.options || []}
                  onChange={option => {
                    field.onChange(option?.value);
                  }}
                />
              </FormControl>
              <FormMessage className="show_error_msg" />
            </FormItem>
          );
        }}
      />
      {required &&
        required === 'Other' &&
        row?.childrens?.map(data => {
          return getComponent(data);
        })}
    </>
  );
};

export default BasicSelect;
